<template>
  <div>
    <h3>Mailing of promotional codes</h3>
    <p>The {{host}} team thanks you for your trust. As a sign of appreciation we will periodically send promotional codes to regular customers. Have a nice game!</p>
  </div>
</template>
<script>
  export default {
    name: 'bonus-rules-mailing-en',
    computed: {
      host() {
        return window.location.hostname;
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/en.vue